import { gql } from '../../../__generated__/graphql/catalog'

export const GET_PRODUCT_IMPRESSION_VARIANTS = gql(`
  query GetProductImpressionVariants($collectionViewHandle: String!, $sectionId: String!) {
    collectionView(handle: $collectionViewHandle) {
      section(id: $sectionId) {
        ... on CollectionGridSection {
          collection {
            id
            handle
            items {
              nodes {
                id
                defaultVariant {
                  externalParentId
                  category
                  discountPrice
                  handle
                  price
                  shopifyId
                  sku
                }
              }
            }
          }
        }
      }
    }
  }
`)
